"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDispatch = void 0;
const react_1 = require("react");
const ssr_redux_context_1 = require("../context/ssr-redux-context");
const useDispatch = () => {
    const context = (0, react_1.useContext)(ssr_redux_context_1.SSRReduxContext);
    if (context === null) {
        throw new Error('You have to wrap component with SSRReduxContext');
    }
    return context.dispatch;
};
exports.useDispatch = useDispatch;
//# sourceMappingURL=use-dispatch.js.map